module.exports = __webpack_public_path__ + "img/32400.a1d5488c.jpg";